import React from 'react';
import styled from 'styled-components';
import contactusvideo from "../../../assets/images/contactUs/contactus.mp4"; // Update this path to your video file

const ContactUsHeader = () => {
  return (
    <Section>
      <Container>
        <Content>
          <Title>Unleash your thoughts & ideas. We're all ears.</Title>
          <Description>
          Your thoughts matter to us. Whether you have questions, feedback, or are interested in collaboration opportunities, we want to hear from you. No question is too big, and no idea is too ambitious. Reach out today, and let’s explore how we can connect!
          </Description>
          <Button href="#contactusform">Get In Touch <i className="fa-solid fa-arrow-right"></i></Button>
        </Content>
        <VideoContainer>
          <Video autoPlay muted loop>
            <source src={contactusvideo} type="video/mp4" />
            Your browser does not support the video tag.
          </Video>
        </VideoContainer>
      </Container>
    </Section>
  );
}

export default ContactUsHeader;

const Section = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;


  @media (min-width: 768px) {
    padding: 60px 40px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 1160px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Content = styled.div`
  flex: 1;
  text-align: center;
  padding: 20px;

  @media (min-width: 768px) {
    text-align: left;
    max-width: 50%;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin: 20px 0;
  font-family: "Poppins", system-ui;
  font-weight: 700;
  font-style: normal;
  text-align: left;
  line-height: 1.4;
  color: #06334b;
  @media (min-width: 768px) {
    font-size: 3rem;
  }

  @media (min-width: 1024px) {
    font-size: 3.5rem;
  }
`;

const Description = styled.p`
  font-size: 1em;
  margin-bottom: 30px;
  color: #777777;
  text-align: justify;
  line-height: 1.8;
   font-family: "Poppins", system-ui;
  font-weight: 400;
  font-style: normal;


  @media (min-width: 768px) {
    font-size: 1.125rem;
  }

  @media (min-width: 1024px) {
    font-size: 1.25rem;
  }
`;

const Button = styled.a`
  display: inline-block;
  padding: 10px 20px;
  font-size: 1rem;
  color: #000;
  border: 2px solid #000;
  border-radius: 0 0 20px 0;
  text-decoration: none;
  transition: background-color 0.3s, color 0.3s;
  justify-content: flex-start;

  &:hover {
    background-color: #000;
    color: #fff;
  }

  @media (min-width: 768px) {
    font-size: 1.125rem;
    padding: 12px 24px;
  }

  @media (min-width: 1024px) {
    font-size: 1.25rem;
    padding: 14px 28px;
  }
`;

const VideoContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  @media (min-width: 768px) {
    margin-top: 0;
    max-width: 50%;
  }
`;

const Video = styled.video`
  max-width: 100%;
  height: auto;
  border-radius: 10px;
`;
